import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    gap: 10px;  
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    
    @media (max-width: 900px) {
        gap: 12px;
    }
`;

export const ContentItems = styled.div<{isFill: boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    
    padding: ${(props) => props.isFill ? '12px 8px' : '0px'};
    border-radius: 4px;
    
    background-color: ${(props) => props.isFill ? props.theme.colors.gray.gray_50 : props.theme.colors.white};
    
    @media (max-width: 900px) {
        height: ${(props) => props.isFill ? '20%' : '100%'};
        overflow-x: scroll;
    }
`;

export const DividerGraph = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    height: 400px;

    @media (max-width: 900px) {
        flex-direction: column;
        height: 100%;
    }
`;

export const FrameGraph = styled.div<{isLarge: boolean}>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    box-shadow: 0 1px 2px 0px rgb(0,0,0, .25);
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    padding: 8px 16px;
    width: ${(props) => props.isLarge ? '70%' : '28%'};
    
    @media (max-width: 900px) {
        width: 100%;
        height: 100%;
    }
`;

export const LabelGraph = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    span{
        color: ${(props) => props.theme.colors.primary};
    }
`;

export const ContentLine = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
`;

export const CorLegenda = styled.div<{ color: string }>`
    background-color: ${({ color }) => color};
    border-radius: 50%;
    height: 10px;
    width: 10px;
`;